import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "visCheckSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Component ID", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, " Used to check whether the component is currently visible for the player ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        ref: "test",
        class: "componentIdInput",
        onFocus: _cache[1] || (_cache[1] = $event => (_ctx.idWatcher = val => (_ctx.action.targetId = val))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.targetId = $event))
      }, null, 544), [
        [_vModelText, _ctx.action.targetId]
      ])
    ]),
    _createVNode("p", {
      class: ["label", _ctx.components[_ctx.action.targetId] ? '' : 'red-text']
    }, " TARGET" + _toDisplayString(!_ctx.components[_ctx.action.targetId]
          ? " NOT FOUND!"
          : ": " + _ctx.components[_ctx.action.targetId].name), 3),
    _hoisted_4
  ]))
}